<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <productListingsPriceCalculation/>
    </v-dialog>
</template>

<script>
    import productListingsPriceCalculation from './ProductListingsPriceCalculation.vue'

    // Settings Types
    import {
        ProductListings
    } from '../../../store/namespace-helper'

    export default {
      name: 'ProductListingsPriceCalculationDialog',
      components: {
        productListingsPriceCalculation
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[ProductListings.getters.getCalculationDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProductListings/ProductListingsPriceCalculations/ProductListingsPriceCalculationDialog.vue